<div class="ui container">
  <div class="ui breadcrumb">
    <a [routerLink]="['/']">
      Bounties List
    </a>
    <i class="right angle icon divider"></i>
    <div class="active section">Bounty</div>
  </div>

  <div class="ui stackable grid section">
    <div class="row">
      <div class="sixteen wide column">
        <h1 class="ui inverted header">
          Bounty Details
          <div *ngIf="isOwner" class="ui blue tag label">You are
            the bounty owner</div>
          <a *ngIf="!isOwner && bounty && bounty.userHasClaimed"
            class="ui green tag label" [routerLink]="['/claims/' + userClaim.id]">
            Claim submitted
          </a>
        </h1>
      </div>
    </div>
    <div class="row no-padding">
      <div class="sixteen wide column">
        <div *ngIf="bounty && user" class="ui dropdown icon primary button"
          suiDropdown>
          <div class="text">
            Actions
          </div>
          <i class="ellipsis vertical icon"></i>
          <div class="menu" suiDropdownMenu>
            <a *ngIf="canViewOwnClaim" class="item" [routerLink]="['/claims/' + userClaim.id]">
              <i class="eye icon"></i> View your claim
            </a>
            <a *ngIf="canViewWinningClaim" class="item"
              [routerLink]="['/claims/' + winningClaim.id]">
              <i class="eye icon"></i> View winning claim
            </a>
            <div *ngIf="canEditBounty" class="item" (click)="editBounty()">
              <i class="orange edit icon"></i>
              Edit Bounty
            </div>
            <div *ngIf="canDeleteBounty" class="item" (click)="deleteBounty()">
              <i class="red trash icon"></i>
              Delete Bounty
            </div>
            <div *ngIf="userCanClaim" class="item" (click)="claimBountyAction()">
              <i class="green money icon"></i>
              Claim Reward
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!bounty" class="ui basic very padded segment">
    <div class="ui inverted active centered inline huge text loader">
      Loading bounty...
    </div>
  </div>

  <div class="main-section" *ngIf="bounty">
    <div *ngIf="isOwner && bounty.status === 'complete' && !bounty.winning_claim"  class="ui message">
      Your bounty has ended. You can renew this bounty by clicking 'Edit Bounty' (in the 'Actions' menu)
      and changing the duration of the bounty.
    </div>
    <div *ngIf="bounty.userIsWinner" class="ui green message">
      <div class="header">
        Congratulations, you won this bounty!
      </div>
      <div *ngIf="bounty.status === 'winner-chosen'">
        <p>
          Please get in contact with the bounty Creator to ask
          for
          your payment.
          Once you have received payment, please mark this
          bounty
          as Payment Received. You can mark payment as received
          on the
          <a [routerLink]="['/claims/' + userClaim.id]">claim's
            page</a>
        </p>
        <p>
          If you have been unable to contact the bounty creator
          for 7 days, please
          contact a site admin.
        </p>
      </div>
    </div>

    <div *ngIf="isOwner && hasNewClaims" class="ui yellow message">
      <div class="header">Your bounty has new reward claims</div>
      <p>
        Please accept or deny the new claims in the Reward
        Claims section of this page.
      </p>
    </div>

    <table class="ui inverted very basic unstackable table">
      <thead>
        <th>Status</th>
        <th *ngIf="bounty.winningUser">
          Winner
        </th>
        <th>Created by</th>
        <th *ngIf="bounty.type === 'beatmap'">Beatmap Link</th>
        <th>Created at (UTC)</th>
        <th>Ends at (UTC)</th>
      </thead>
      <tbody>
        <tr>
          <td>
            <div class="ui label" [ngClass]="statusColors[bounty.status]">
              {{ bounty.status }}
            </div>
          </td>
          <td *ngIf="bounty.winningUser">
            <app-user-label [user]="bounty.winningUser"></app-user-label>
          </td>
          <td>
            <app-user-label [user]="bounty.owner"></app-user-label>
          </td>
          <td *ngIf="bounty && bounty.type === 'beatmap'">
            <a class="ui tiny teal button" *ngIf="bounty.type === 'beatmap'"
              target="_blank" [href]="beatmapHref" (click)="onBeatmapHrefClicked($event)">
              View Beatmap
            </a>
          </td>
          <td>
            {{bounty.created_at | date:'short'}}
          </td>
          <td>
            {{bounty.ends_at | date:'short'}}
          </td>
        </tr>
      </tbody>
    </table>

    <div class="section">
      <h2>Bounty Rules</h2>
      <app-bounty-card *ngIf="bounty" [bounty]="bounty"
        [isListing]="false">
      </app-bounty-card>
    </div>

    <div class="section" *ngIf="bounty.claims">
      <h2 class="ui inverted header">Reward Claims</h2>
      <p *ngIf="!bounty.claims.length">No one has claimed this
        bounty reward yet.</p>
      <table class="ui inverted table" *ngIf="bounty.claims.length"
        [class.selectable]="isOwner || isMod">
        <thead>
          <th>Username</th>
          <th class="center aligned">Claim status</th>
          <th>Claim submitted</th>
          <th>Submitted on</th>
        </thead>
        <tbody>
          <tr *ngFor="let claim of bounty.claims" (click)="goToClaim(claim)"
            [class.selectable]="isClaimer(claim)">
            <td>{{ claim.user.osu_username }} </td>
            <td class="center aligned">
              <div class="ui label" [ngClass]="getStatusColor(claim)">
                {{claim.status}}
              </div>
            </td>
            <td>{{ claim.createdHumanReadable }}</td>
            <td>{{ claim.created_at | date:'medium' }} (UTC)</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="section" *ngIf="bounty.payment_type === 'pool'">
      <h2>Reward pool contributions</h2>
      <p>
        {{bounty.poolContributions.length}}
        {{bounty.poolContributions.length > 1 ? 'people have' :
        'person has'}}
        contributed to the reward pool.
      </p>
      <div class="ui green button" (click)="showAddToPoolForm = true"
        *ngIf="!showAddToPoolForm && !bounty.completed_at">
        Add to the reward pool
      </div>
      <div *ngIf="showAddToPoolForm">
        <p>
          All additions to the reward pool must be prepaid in
          order to
          guarantee the winner gets the full amount shown. This
          amount is refundable
          up until the point where a winner of the bounty is
          chosen.
        </p>
        <p>
          If the bounty ends with no winner chosen, all
          contributions to this pool will be automatically
          refunded.
        </p>
        <p>
          A transaction fee of 10% is applied to all payments.
          For more information about how we collect and
          distribute pooled bounty rewards, view the FAQ.
        </p>
        <div class="field">
          <div class="ui inverted form">
            <div class="field">
              <label>
                Amount to add in USD (Minimum $1, Maximum:
                $1000)
              </label>
              <input type="number" name="reward" placeholder="$1"
                [(ngModel)]="amountToAdd" min="1" max="1000"
                [class.error]="amountToAdd < 1 || amountToAdd> 1000">
            </div>
            <div class="field">
              <app-payment-form *ngIf="showAddToPoolForm"
                [amount]="amountValid ? parseReward(amountToAdd) : amountToAdd"
                [bountyId]="bounty.id">
              </app-payment-form>
            </div>
          </div>
        </div>
      </div>
      <div class="ui inverted relaxed divided list pool-contributions">
        <div class="item" *ngFor="let item of bounty.poolContributions">
          <i class="green money icon"></i>
          <div class="content">
            <div class="header">
              <app-user-label [user]="item.user"></app-user-label>
              added {{ item.amount | currency }} to the reward
              pool
            </div>
            <div class="description">{{
              item.createdHumanReadable }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="section" *ngIf="!user">
      <h2>Claim Reward</h2>
      <div *ngIf="!this.user && !userCanClaim">
        <p>Log in to claim this reward</p>
        <a href="/login" class="ui orange button">
          Log in
        </a>
      </div>
    </div>
    <div class="section" id="claim-reward-section" *ngIf="!isOwner && userCanClaim">
      <h2>Claim reward</h2>
      <p *ngIf="!showClaimBountyForm">
        Have you completed this challenge? Click 'Claim
        Reward' and provide evidence of
        your scores.
      </p>

      <app-claim-bounty-form *ngIf="showClaimBountyForm"
        [bounty]="bounty" (claimCreated)="onClaimCreated($event)"></app-claim-bounty-form>

      <button class="ui primary button" *ngIf="!showClaimBountyForm"
        (click)="showClaimBountyForm = true">
        Claim Reward
      </button>
    </div>

    <div *ngIf="createdClaimId" class="ui inverted success message">
      <p>You have successfully submitted your claim to this
        bounty.</p>
      <p>
        Your claim will be reviewed soon. Follow the status of
        your claim using
        the button below or from your profile.
      </p>
      <button *ngIf="createdClaimId" class="ui primary button"
        [routerLink]="['/claims/' + createdClaimId]">
        View claim
      </button>
    </div>
  </div>

  <div class="ui container">
    <app-comments-section *ngIf="comments" [comments]="comments"
      [resourceName]="'bounties'" [id]="bounty.id" [ownerId]="bounty.user_id"
      (refetch)="refetch()">
    </app-comments-section>
  </div>

</div>
